/**
 * One import per chunk, marked fulfilled once it loads, the way React's `use`
 * reads a settled promise: a page whose chunk has arrived then renders in the
 * same pass instead of suspending. React.lazy always suspends once, and React
 * then holds the page back by its fallback throttle (about 300 ms), even when
 * the chunk is already there. A failed import stays failed, as React.lazy's
 * does: RoutePage offers the reload.
 */
function cached<T>(load: () => Promise<T>): () => Promise<T> {
  let loading: Promise<T> | undefined
  return () => {
    if (!loading) {
      const promise = load()
      promise.then(value => {
        Object.assign(promise, { status: 'fulfilled', value })
      }, () => undefined)
      loading = promise
    }
    return loading
  }
}

// The sign-in pages' chunks, read by App's routes. main.tsx starts the
// visitor's likely page alongside the session check, not after it.
export const loadLoginPage = cached(() => import('./LoginPage'))
export const loadMagicLoginPage = cached(() => import('./MagicLoginPage'))
